(function () {
  'use strict';

  var MASK = [
    [0,0,1,1,1,1,1,0,0],
    [0,1,1,1,1,1,1,1,0],
    [1,1,1,1,1,1,1,1,1],
    [1,1,1,1,1,1,1,1,1],
    [1,1,1,1,1,1,1,1,1],
    [1,1,1,1,1,1,1,1,1],
    [1,1,1,1,1,1,1,1,1],
    [0,1,1,1,1,1,1,1,0],
    [0,0,1,1,1,1,1,0,0]
  ];

  var CX = 4;
  var CY = 4;
  var MAX_D = Math.sqrt(CX * CX + CY * CY);

  function hexToRgba(hex, a) {
    var h = (hex || '#888888').replace('#', '');

    if (h.length === 3) {
      h = h[0] + h[0] + h[1] + h[1] + h[2] + h[2];
    }

    return 'rgba(' +
      parseInt(h.slice(0, 2), 16) + ',' +
      parseInt(h.slice(2, 4), 16) + ',' +
      parseInt(h.slice(4, 6), 16) + ',' +
      a.toFixed(2) + ')';
  }

  function initRoot(root) {
    if (!root || root.dataset.lmReady === '1') return;

    var MODES = [];
    try {
      MODES = JSON.parse(root.dataset.modes || '[]') || [];
    } catch (err) {
      MODES = [];
    }

    if (!MODES.length) return;

    root.dataset.lmReady = '1';

    var current = 0;

    var grid = root.querySelector('.lm__grid');
    var sw = root.querySelector('.lm__switcher');
    var disp = root.querySelector('.lm__display');

    function safeText(selector, value) {
      var el = root.querySelector(selector);
      if (el) el.textContent = value || '';
    }

    function buildGrid() {
      if (!grid) return;

      grid.innerHTML = '';

      MASK.forEach(function (row, r) {
        row.forEach(function (vis, c) {
          var dot = document.createElement('div');

          if (!vis) {
            dot.className = 'lm__dot lm__dot--off';
          } else {
            var d = Math.sqrt((c - CX) * (c - CX) + (r - CY) * (r - CY));
            dot.className = 'lm__dot';
            dot.dataset.d = d.toFixed(3);
          }

          grid.appendChild(dot);
        });
      });
    }

    function buildSwitcher() {
      if (!sw) return;

      sw.innerHTML = '';

      MODES.forEach(function (m, i) {
        var btn = document.createElement('button');

        btn.className = 'lm__pill' + (i === 0 ? ' is-active' : '');
        btn.style.setProperty('--pill-color', m.hex);
        btn.setAttribute('aria-label', m.name || 'Light mode');
        btn.setAttribute('type', 'button');

        btn.addEventListener('click', function () {
          activate(i);
        });

        sw.appendChild(btn);
      });
    }

    function setMode(idx) {
      current = idx;

      var m = MODES[idx];
      if (!m) return;

      root.querySelectorAll('.lm__grid .lm__dot:not(.lm__dot--off)')
        .forEach(function (dot) {
          var d = parseFloat(dot.dataset.d);
          var ratio = 1 - d / MAX_D;

          dot.style.backgroundColor = hexToRgba(m.hex, 0.62 + ratio * 0.38);
          dot.style.boxShadow =
            '0 0 ' + (6 + ratio * 10).toFixed(1) + 'px ' +
            (1 + ratio * 4).toFixed(1) + 'px ' +
            hexToRgba(m.hex, 0.55 + ratio * 0.25);
        });

      if (disp) {
        var base = getComputedStyle(disp).getPropertyValue('--lm-bg-display').trim() || '#111111';

        disp.style.background =
          'radial-gradient(ellipse at 50% 50%, ' +
          hexToRgba(m.hex, 0.12) +
          ' 0%, ' +
          base +
          ' 68%)';
      }

      safeText('.lm__mode-name', m.name);
      safeText('.lm__wavelength-num', m.nm);
      safeText('.lm__tagline', m.tag);

      safeText('.lm__desc', m.desc);
      safeText('[data-lm-field="peak"]', m.peak);
      safeText('[data-lm-field="avg"]', m.avg);
      safeText('[data-lm-field="dose"]', m.dose);
      safeText('[data-lm-field="unif"]', m.unif);

      root.querySelectorAll('.lm__switcher .lm__pill')
        .forEach(function (p, i) {
          p.classList.toggle('is-active', i === idx);
        });
    }

    function activate(idx) {
      if (idx === current) return;
      setMode(idx);
    }

    function goNext() {
      if (!MODES.length) return;
      setMode((current + 1) % MODES.length);
    }

    function goPrev() {
      if (!MODES.length) return;
      setMode((current - 1 + MODES.length) % MODES.length);
    }

    function bindSwipe() {
      if (!disp || disp.dataset.swipeReady === '1') return;

      disp.dataset.swipeReady = '1';

      var startX = 0;
      var startY = 0;
      var endX = 0;
      var endY = 0;
      var isDown = false;

      var threshold = 42;
      var directionLock = null;

      function onStart(e) {
        if (e.pointerType === 'mouse' && e.button !== 0) return;

        isDown = true;
        directionLock = null;

        startX = e.clientX;
        startY = e.clientY;
        endX = startX;
        endY = startY;

        if (disp.setPointerCapture) {
          try {
            disp.setPointerCapture(e.pointerId);
          } catch (err) {}
        }
      }

      function onMove(e) {
        if (!isDown) return;

        endX = e.clientX;
        endY = e.clientY;

        var dx = endX - startX;
        var dy = endY - startY;

        if (!directionLock) {
          if (Math.abs(dx) > 10 || Math.abs(dy) > 10) {
            directionLock = Math.abs(dx) > Math.abs(dy) ? 'x' : 'y';
          }
        }

        if (directionLock === 'y') return;

        if (Math.abs(dx) > threshold && Math.abs(dx) > Math.abs(dy) * 1.25) {
          if (dx < 0) {
            goNext();
          } else {
            goPrev();
          }

          isDown = false;
        }
      }

      function onEnd(e) {
        isDown = false;
        directionLock = null;

        if (e && disp.releasePointerCapture) {
          try {
            disp.releasePointerCapture(e.pointerId);
          } catch (err) {}
        }
      }

      disp.addEventListener('pointerdown', onStart);
      disp.addEventListener('pointermove', onMove);
      disp.addEventListener('pointerup', onEnd);
      disp.addEventListener('pointercancel', onEnd);
      disp.addEventListener('pointerleave', onEnd);
    }

    buildGrid();
    buildSwitcher();
    setMode(0);
    bindSwipe();

    root.addEventListener('al-block-select', function (e) {
      if (!e.detail) return;
      var idx = MODES.findIndex(function (m) {
        return m.id === e.detail.blockId;
      });
      if (idx !== -1) setMode(idx);
    });
  }

  function initAll(scope) {
    var roots = (scope || document).querySelectorAll('.al-led-light-modes-dark');
    roots.forEach(initRoot);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { initAll(); });
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', function (e) {
    if (e.target) initAll(e.target);
  });

  document.addEventListener('shopify:block:select', function (e) {
    if (!e.detail) return;
    var root = e.target && e.target.closest
      ? e.target.closest('.al-led-light-modes-dark')
      : null;
    if (!root) return;
    root.dispatchEvent(new CustomEvent('al-block-select', { detail: { blockId: e.detail.blockId } }));
  });
}());
